module.exports = __webpack_public_path__ + "static/media/jackpot.d6e37f44.svg";